import { render, staticRenderFns } from "./CopyrightFormsDetails.vue?vue&type=template&id=523e320b&scoped=true&"
import script from "./CopyrightFormsDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightFormsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightFormsDetails.vue?vue&type=style&index=0&id=523e320b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e320b",
  null
  
)

export default component.exports